import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalUserAnswersQuestionsPageRoutingModule } from './modal-user-answers-questions-routing.module';

import { ModalUserAnswersQuestionsPage } from './modal-user-answers-questions.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalUserAnswersQuestionsPageRoutingModule
  ],
  declarations: [ModalUserAnswersQuestionsPage]
})
export class ModalUserAnswersQuestionsPageModule {}
